(() => {
  const d = document;

  // Header gains a frosted surface once the page moves
  const hdr = d.querySelector('[data-hdr]');
  if (hdr) {
    const on = () => hdr.classList.toggle('is-scrolled', scrollY > 8);
    on();
    addEventListener('scroll', on, { passive: true });
  }

  // Reveal on enter, once
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  d.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // Filtration stages: the step crossing mid-screen is active, the meter fills with it
  d.querySelectorAll('[data-process]').forEach((sec) => {
    const steps = [...sec.querySelectorAll('[data-step]')];
    const meter = sec.querySelector('[data-meter]');
    const so = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      steps.forEach((s) => s.classList.toggle('is-active', s === e.target));
      meter?.style.setProperty('--p', (steps.indexOf(e.target) + 1) / steps.length);
    }), { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => so.observe(s));
  });

  // Launch-offer countdown to the fixed end date in data-countdown (unix seconds); hides at zero
  d.querySelectorAll('[data-countdown]').forEach((el) => {
    const end = Number(el.dataset.countdown) * 1000;
    const out = el.querySelector('[data-cd]');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!s) { el.hidden = true; return; }
      const days = Math.floor(s / 86400);
      out.textContent = `${days ? `${days}d ` : ''}${pad(Math.floor(s % 86400 / 3600))}h ${pad(Math.floor(s % 3600 / 60))}m ${pad(s % 60)}s`;
      setTimeout(tick, 1000);
    };
    tick();
  });
  d.querySelectorAll('[data-copy]').forEach((b) => b.addEventListener('click', () => {
    navigator.clipboard?.writeText(b.dataset.copy).then(() => {
      b.textContent = '✓';
      setTimeout(() => { b.textContent = b.dataset.copy; }, 1200);
    });
  }));

  // Water ripple on press; reduced motion gets a static glow instead
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  d.addEventListener('pointerdown', (e) => {
    const el = e.target.closest('.btn, .promo-note__code, .pill span, .announce--promo');
    if (!el) return;
    const r = el.getBoundingClientRect();
    const s = Math.hypot(r.width, r.height) * 2;
    (still.matches ? [0] : [0, 160]).forEach((delay) => {
      const ring = d.createElement('span');
      ring.className = still.matches ? 'ripple ripple--still' : 'ripple';
      ring.setAttribute('aria-hidden', 'true');
      ring.style.cssText = `--s:${s}px;left:${e.clientX - r.left}px;top:${e.clientY - r.top}px;animation-delay:${delay}ms`;
      ring.addEventListener('animationend', () => ring.remove());
      el.appendChild(ring);
    });
  });

  // Product form
  const form = d.getElementById('pdp-form');
  if (!form) return;
  const btn = form.querySelector('[data-add]');
  const idInput = form.querySelector('[data-variant-id]');
  const err = form.querySelector('[data-error]');

  // Sticky mobile buy bar appears once the main button has scrolled above the viewport
  const bar = d.querySelector('[data-buybar]');
  if (bar && btn) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.querySelector('button').tabIndex = on ? 0 : -1;
    }).observe(btn);
  }

  // Auto-renewal consent is mandatory only while a subscription plan is selected
  const consent = form.querySelector('[data-consent] input');
  const syncConsent = () => {
    if (consent) consent.required = Boolean(form.querySelector('input[name="selling_plan"]:checked')?.value);
  };
  syncConsent();
  form.addEventListener('change', (e) => { if (e.target.name === 'selling_plan') syncConsent(); });

  const vjson = form.querySelector('[data-variants]');
  if (vjson) {
    const variants = JSON.parse(vjson.textContent);
    let cur = variants.find((x) => x.id === Number(idInput.value));
    form.addEventListener('change', (e) => {
      if (!e.target.name?.startsWith('opt')) return;
      const sel = [...form.querySelectorAll('.opt')].map((fs) => fs.querySelector('input:checked')?.value);
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      btn.disabled = !v?.available;
      btn.textContent = !v ? btn.dataset.lNa : v.available ? btn.dataset.lAdd : btn.dataset.lSold;
      if (bar) bar.querySelector('button').disabled = btn.disabled;
      if (!v) return;
      // Prices and renewal disclosures are server-rendered; a new price needs a fresh render
      if (v.price !== cur?.price) return location.replace(`?variant=${v.id}`);
      cur = v;
      idInput.value = v.id;
      history.replaceState(null, '', `?variant=${v.id}`);
    });
  }

  // Purifier + filter plan go to the cart together; without the add-on the native submit runs
  form.addEventListener('submit', async (e) => {
    const toggle = form.querySelector('[data-addon-toggle]');
    if (!toggle?.checked) return;
    e.preventDefault();
    const fd = new FormData(form);
    const box = toggle.closest('[data-addon]');
    const item = (id, plan) => ({ id: Number(id), quantity: 1, ...(plan ? { selling_plan: Number(plan) } : {}) });
    const items = [item(fd.get('id'), fd.get('selling_plan')), item(box.dataset.variant, box.dataset.plan)];
    btn.disabled = true;
    err.hidden = true;
    try {
      const r = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description);
      location.href = btn.dataset.cartUrl;
    } catch (ex) {
      err.textContent = ex.message || err.textContent;
      err.hidden = false;
      btn.disabled = false;
    }
  });
})();
